import React from 'react'
import PieChart from './PieChart'
import StatusBarChart from './StatusBarChart'
import AreaChart from './AreaChart'

const InvoiceOvertime = () => {
  return (
    <div class="col-md-8 col-12 mb-2 pb-1">
      <div class="card mb-0 border-0 shadow-none ">
        <div class="card-header sh_accordionheader">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-md font-weight-bold mb-0">Invoice Overtime </h6>
            <div>
              <div class="tabs_wrapForTable">
                <div class="nav sh_subnav border-0"><label class="flex-sm-fill text-sm-center nav-link " style={{"cursor": "pointer"}}>
                  <input class="form-check-input" type="radio" name="scheduleType" id="default" tabindex="0" checked="" style={{"display": "none"}}/>
                  <span class="name ">Days</span></label><label class="flex-sm-fill text-sm-center nav-link " style={{"cursor": "pointer"}}>
                    <input class="form-check-input" type="radio" name="scheduleType" id="default" tabindex="0" style={{"display": "none"}} />
                    <span class="name ">Weeks</span></label><label class="flex-sm-fill text-sm-center nav-link active" style={{"cursor": "pointer"}}>
                      <input class="form-check-input" type="radio" name="scheduleType" id="default" tabindex="0" style={{"display": "none"}}/>
                      <span class="name font-weight-bold">Months</span></label></div>
              </div>
            </div>
          </div>
        </div>
        <div class="card-body px-0 py-2">
          <div class="w-100">
            <AreaChart/>
            {/* <StatusBarChart /> */}
            {/* <div class="sh_dashchartcontainer">
              <canvas id="areaChart" style={{
                display: "block",
                boxSizing: "border-box",
                height: "184px",
                width: "368px",
              }} width="368" height="184"></canvas>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}

export default InvoiceOvertime